
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogActions,
  MatDialogContent,
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { UserManagementService } from '../../service/user-management.service';

export interface UnauthorizedDialogData {
  message?: string;
}

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButtonModule],
  templateUrl: './unauthorized.component.html',
  styleUrl: './unauthorized.component.scss'
})
export class UnauthorizedComponent {
  message: string;

  private dialogRef = inject<MatDialogRef<UnauthorizedComponent>>(MatDialogRef);
  private userManagementService = inject(UserManagementService);
  public data = inject<UnauthorizedDialogData>(MAT_DIALOG_DATA, { optional: true });

  constructor() {
    this.message = this.data?.message || 'You are not authorized to access this portal.';
  }

  close() {
    this.dialogRef.close();
    this.userManagementService.forceLogout();
  }
}
